var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('button',{attrs:{"id":"close"},on:{"click":_vm.close}},[_vm._v(" × ")]),_c('h2',[_vm._v(_vm._s(_vm.content.Title))])])}
var staticRenderFns = []

export { render, staticRenderFns }